import React from 'react';
import PropTypes from 'prop-types';

class Productfeaturescomponent extends React.Component {
  constructor(props) {
    super(props);

  }

  render() {
    const sidePanelInfo = this.props.dataarray;
    const newsidePanelInfo =  sidePanelInfo.filter(value => Object.keys(value).length !== 0);
    const name = this.props.name;
    const key = this.props.id;
    //const slugId = this.props.slugId;
    return (
      <div className = "sidepanelcomponent">
        {!newsidePanelInfo.length > 0 ? <span /> :
          <div className="parentdiv">
            <h2 className="vx_text-2 content-name">{name}</h2>
            <ul className="section-container">
              {newsidePanelInfo.slice(0, this.props.showItems).map((panel, index) => {
                const url = panel.url && (panel.url).includes("http") ? panel.url : `https://${panel.url}`;
                return (
                <li className="list-item" key={index}>
                    {!panel.title ? <span /> :
                      <div className="title-true" key={panel.downloadlink + index}>
                          <hr className="h-line" />
                          <div><a data-pa-click={`brcRightRail|${key}|${url}`} target = "_blank" tabIndex="-1" aria-label="button as arrow"
                            className="rightarrow" href = {url} /></div>
                             <h3 className="list-link _title">
                              <a data-pa-click={`brcRightRail|${key}|${url}`} target = "_blank" className="list-link _title" href={url}>
                                {panel.title}
                              </a>
                             </h3>
                          <div className="vx_text-body _shortdesc" key={panel.desc + index}>
                              {panel.desc}
                           </div>
                          {!panel.img ? <span /> :
                             <a data-pa-click={`brcRightRail|${key}|${url}`} href= {url} target = "_blank" className="set-image"
                               style={{backgroundImage: `url(${panel.img})`}}>{panel.title}</a>
                          }
                      </div>
                    }
                </li>
                );
              })}
            </ul>
          </div>
        }
      </div>
    );
  }
}
export default Productfeaturescomponent;

Productfeaturescomponent.propTypes = {
  //articleInfo: PropTypes.array,
  dataarray: PropTypes.array,
  name: PropTypes.string,
  showItems: PropTypes.number,
  id: PropTypes.string,
  slugId: PropTypes.string
};
